module.exports = __webpack_public_path__ + "static/media/15.eed32d17.jpg";